import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { AuthGuard } from './auth/auth.guard';
import { MenuEnabledGuard } from './auth/menu-enabled.guard';
import { LoginComponent } from './pages/login/login.component';
import { DocumentListComponent } from './pages/document-list/document-list.component';
import { DocumentDetailPageComponent } from './pages/document-detail-page/document-detail-page.component';
import { DocumentChunkEditComponent } from './pages/document-chunk-edit/document-chunk-edit.component';
import { ChatPageComponent } from './pages/chat-page/chat-page.component';
import { PromtPageComponent } from './pages/promt-page/promt-page.component';
import { PluginPageComponent } from './pages/plugin-page/plugin-page.component';
import { PlannerPageComponent } from './pages/planner-page/planner-page.component';
import { RagPageComponent } from './pages/rag-page/rag-page.component';
import { ChatStreamPageComponent } from './pages/chat-stream-page/chat-stream-page.component';
import { PlanPageComponent } from './pages/plan-page/plan-page.component';
import { RagFlowPageComponent } from './pages/rag-flow-page/rag-flow-page.component';
import { environment } from '../environments/environment';

const authGuard = environment.login ? [AuthGuard] : [];


const defaultMenuToRoute: Record<string, string> = {
  ragflow: '/ragflow',
  chat: '/chat',
  planner: '/planner',
  documents: '/documents',
  templates: '/templates',
  plugins: '/plugins',
  plan: '/plan',
};

const originalDefaultRedirect = environment.standalone
  ? '/plan'
  : (environment.menu.chat ? '/chat' : '/dashboard');

const defaultMenu = environment.defaultMenu as keyof typeof defaultMenuToRoute | undefined;
const defaultMenuRoute = defaultMenu ? defaultMenuToRoute[defaultMenu] : undefined;
const defaultMenuEnabled = defaultMenu ? (environment.menu as any)?.[defaultMenu] === true : false;

const defaultRedirect =
  defaultMenuRoute
    ? (defaultMenuEnabled ? defaultMenuRoute : '/dashboard')
    : originalDefaultRedirect;

/* ---------------- ROUTES ---------------- */

const standaloneRoutes: Routes = [

  { path: 'login', component: LoginComponent },

  { path: 'dashboard', component: DashboardComponent, canActivate: authGuard },

  { path: 'documents',
    component: DocumentListComponent,
    canActivate: [...authGuard, MenuEnabledGuard],
    data: { menuKey: 'documents' }
  },

  { path: 'templates',
    component: PromtPageComponent,
    canActivate: [...authGuard, MenuEnabledGuard],
    data: { menuKey: 'templates' }
  },

  { path: 'chat-stream',
    component: ChatStreamPageComponent,
    canActivate: [...authGuard, MenuEnabledGuard],
    data: { menuKey: 'chat' }
  },

  { path: 'chat',
    component: ChatPageComponent,
    canActivate: [...authGuard, MenuEnabledGuard],
    data: { menuKey: 'chat' }
  },

  { path: 'chat/:id',
    component: ChatPageComponent,
    canActivate: [...authGuard, MenuEnabledGuard],
    data: { menuKey: 'chat' }
  },

  { path: 'documents/:id',
    component: DocumentDetailPageComponent,
    canActivate: [...authGuard, MenuEnabledGuard],
    data: { menuKey: 'documents' }
  },

  { path: 'documents/:id/edit-chunk/:chunkid',
    component: DocumentChunkEditComponent,
    canActivate: [...authGuard, MenuEnabledGuard],
    data: { menuKey: 'documents' }
  },

  { path: 'plugins',
    component: PluginPageComponent,
    canActivate: [...authGuard, MenuEnabledGuard],
    data: { menuKey: 'plugins' }
  },

  { path: 'planner',
    component: PlannerPageComponent,
    canActivate: [...authGuard, MenuEnabledGuard],
    data: { menuKey: 'planner' }
  },

  { path: 'planner/:plannerId',
    component: PlannerPageComponent,
    canActivate: [...authGuard, MenuEnabledGuard],
    data: { menuKey: 'planner' }
  },

  { path: 'plan',
    component: PlanPageComponent,
    canActivate: [...authGuard, MenuEnabledGuard],
    data: { menuKey: 'plan' }
  },

  { path: 'ragflow',
    component: RagFlowPageComponent,
    canActivate: [...authGuard, MenuEnabledGuard],
    data: { menuKey: 'ragflow' }
  },

  { path: 'chat/:chatId/rag-editor/:ragId',
    component: RagPageComponent,
    canActivate: [...authGuard, MenuEnabledGuard],
    data: { menuKey: 'ragflow' }
  },

  { path: 'chat/:chatId/planner-editor/:plannerId',
    component: PlannerPageComponent,
    canActivate: [...authGuard, MenuEnabledGuard],
    data: { menuKey: 'planner' }
  },

  { path: 'chat/:chatId/rag-silent/:ragId',
    component: RagPageComponent,
    canActivate: [...authGuard, MenuEnabledGuard],
    data: { menuKey: 'ragflow' }
  },

  { path: 'chat/:chatId/planner-silent/:plannerId',
    component: PlannerPageComponent,
    canActivate: [...authGuard, MenuEnabledGuard],
    data: { menuKey: 'planner' }
  },

  { path: '', redirectTo: defaultRedirect, pathMatch: 'full' },
  { path: '**', redirectTo: defaultRedirect }

];

const routes: Routes = environment.standalone
  ? standaloneRoutes
  : standaloneRoutes;

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
